// Angular
import { Component, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { OnChanges } from '@angular/core';
import { ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { SimpleChange } from '@angular/core';
import { ElementRef } from '@angular/core';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-reload-sprocket',
  templateUrl: './reload.sprocket.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ReloadSprocketComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit {
  @Input() tile = '';
  @Output() reload: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private el: ElementRef,
  ) {
    console.log('ReloadSprocket: Constructor');
  }

  public btnClick(): void {
    this.reload.emit(this.tile);
  }

  ngAfterContentInit() {
    // console.log('ReloadSprocket: ngAfterContentInit');
  }

  ngOnInit() {
    // console.log('ReloadSprocket: ngOnInit:' + this.tile);
  }

  ngOnDestroy() {
    // console.log('ReloadSprocket: ngOnDestroy');
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.tile) {
      if (changes.tile.currentValue && changes.tile.currentValue.length > 0) {
        this.tile = changes.tile.currentValue;
      }
    }
  }
}
